import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk_reload_at";

// After a new deploy, old chunk files disappear. A browser holding the previous
// index.js then fails to import lazy chunks ("Importing a module script failed").
// Reload once to fetch the fresh bundle; guard against reload loops.
export const lazyWithRetry = <T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) =>
  lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (error) {
      const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
      if (Date.now() - last > 10000) {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
        window.location.reload();
        return new Promise<{ default: T }>(() => undefined);
      }
      console.error("Failed to load page chunk", error);
      throw error;
    }
  });
